import React from 'react'
import { Field } from 'formik'
import Label from './formLabel'

/**
 * @param {array} options Contains array of object to map over the select input values
 */
const Select = (props) => {
    const {
        label,
        name,
        options,
        setFieldValue,
        handleChangeState,
        changeState,
        ...rest
    } = props
    return (
        <div className='form-group'>
            <Label name={name} label={label} />
            <div className='form-select' id='form-dropdown'>
                <Field
                    as='select'
                    className='form-control input-val'
                    onChange={(e) => {
                        setFieldValue([name], e.target.value)
                    }}
                    id={name}
                    name={name}
                    {...rest}
                >
                    {options.map((option) => {
                        return (
                            <option key={option.key} value={option.value}>
                                {option.key}
                            </option>
                        )
                    })}
                </Field>
            </div>
        </div>
    )
}

export default Select
